<template>
  <v-dialog v-model="show" width="50vw" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2"
        >Eliminar folio en Pozo "<span class="font-weight-bold font-italic">
          {{ wellSelected.value }}</span
        >"</v-card-title
      >
      <v-card-text>
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <span class="text-body-1">
                  ¿Estás segura de que quieres eliminar el folio "{{
                    wellSelected.folioAnalysis
                  }}"?
                </span>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="gray"
                block
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cerrar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="saveData"
                :loading="isLoading"
                >Aceptar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data: () => ({
    isLoading: false,
    user: JSON.parse(localStorage.getItem("user")),
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("molecularPlateWell", ["wellSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async mounted() {},
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("molecularPlateWell", ["deleteSampleInWell"]),

    async saveData() {
      try {
        this.isLoading = true;
        if (this.$refs.form.validate()) {
          let payload = {
            position: this.wellSelected.position,
            molecularPlate: this.wellSelected.plateFolio,
          };
          await this.deleteSampleInWell(payload);
          this.wellSelected.folioAnalysis = undefined;
          this.wellSelected.replica = undefined;
          this.wellSelected.sampleType = undefined;
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: `Pozo eliminado`,
            timeout: 3000,
          });
          this.$emit("close_update");
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: `Algo salió mal. Error: ${error.message}`,
          timeout: 5000,
        });
      } finally {
        this.isLoading = false;
      }
    },
    closeModal() {
      this.show = false;
    },
  },
};
</script>
